module.exports = __webpack_public_path__ + "img/add-new-icon.7162fdda.svg";